module.exports = __webpack_public_path__ + "img/successfullyshared.4be7ac44.svg";